// import React from "react";
// import { Box, Tabs, Tab } from "@mui/material";
// import { styled } from "@mui/system";

// const RoundedTabs = styled(Tabs)(({ theme }) => ({
//   borderRadius: "9999px",
//   backgroundColor: "#F9FAFB",
//   border: "1px solid #E5E7EB",
//   padding: "4px",
//   minHeight: "unset",
//   "& .MuiTabs-indicator": {
//     display: "none", // We handle active tab styling ourselves
//   },
// }));

// const RoundedTab = styled(Tab)(({ theme }) => ({
//   textTransform: "none",
//   fontWeight: 600,
//   fontFamily: "Lexend, sans-serif",
//   fontSize: 14,
//   minHeight: "unset",
//   minWidth: 100,
//   borderRadius: "9999px",
//   padding: "6px 16px",
//   transition: "all 0.3s ease",
//   "&.Mui-selected": {
//     color: "#fff",
//     background: "linear-gradient(90deg, #6366F1 0%, #9F03FF 100%)",
//   },
//   "&:not(.Mui-selected)": {
//     color: "#374151",
//     backgroundColor: "transparent",
//   },
// }));

// interface Props {
//   value: number;
//   onChange: (event: React.SyntheticEvent, newValue: number) => void;
// }

// const SectionTabsUnused: React.FC<Props> = ({ value, onChange }) => {
//   return (
//     <Box display="flex" justifyContent="left" mb={4}>
//       <RoundedTabs value={value} onChange={onChange}>
//         <RoundedTab label="Analytics" />
//         <RoundedTab label="Bookings" />
//         <RoundedTab label="Cards" />
//         <RoundedTab label="Wallet" />
//         <RoundedTab label="Reviews" />
//       </RoundedTabs>
//     </Box>
//   );
// };

// export default SectionTabsUnused;

import React from "react";
import { Box } from "@mui/material";
import CustomTab from "../../common/CustomTab";

interface Props {
  value: string | number;
  onChange: (event: React.SyntheticEvent, newValue: string | number) => void;
}

const tabs = [
  { label: "Analytics", value: "analytics" },
  { label: "Bookings", value: "bookings" },
  { label: "Upcoming Session", value: "upcoming" },
  { label: "Favorite Cards", value: "favorites" },
  { label: "Wallet", value: "wallet" },
];

const SectionTabsTalent: React.FC<Props> = ({ value, onChange }) => {
  return (
    <Box display="flex" justifyContent="left">
      <CustomTab tabs={tabs} value={value} onChange={onChange} />
    </Box>
  );
};

export default SectionTabsTalent;
